import type { Trinket, TrinketName } from "types/layout";
import { useLayoutTrinkets } from "./useLayoutTrinkets";

export const useLayoutTrinket = ({
  trinketName,
  ...options
}: Parameters<typeof useLayoutTrinkets>[0] & {
  trinketName: TrinketName;
}) =>
  useLayoutTrinkets<Trinket | undefined>({
    ...options,
    select: (trinkets) =>
      trinkets.find((trinket) => trinket.name === trinketName),
  });
